// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-containers-404-tsx": () => import("./../../../src/containers/404.tsx" /* webpackChunkName: "component---src-containers-404-tsx" */),
  "component---src-containers-index-tsx": () => import("./../../../src/containers/index.tsx" /* webpackChunkName: "component---src-containers-index-tsx" */),
  "component---src-containers-unauthorised-tsx": () => import("./../../../src/containers/unauthorised.tsx" /* webpackChunkName: "component---src-containers-unauthorised-tsx" */)
}

